import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
  }

  *, *::after, *::before {
    box-sizing: inherit;
  }

  body {
    font-family: 'Poppins', sans-serif;
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.textBlack};
  }

  a, button {
    font-family: 'Poppins', sans-serif;
  }

  a {
    text-decoration: none;
  }

  p {
    margin: 0;
  }
`;
